export default {
  'alertsList.alertName': 'Alert Name',
  'alertsList.alertType': 'Alert Type',
  'alertsList.createdBy': 'Created By',
  'alertsList.noInfo': ' No Information to Display',
  'alertsList.deleteWarning': ' DELETE ALERT(S)',
  'alertsList.content': 'alert(s) will be deleted and will be permanently removed',
  'alertsList.deleteMessage': 'Alert(s) Deleted Successfully',
  'alertsList.allAlerts': 'All Alerts'
};
